export type SelectorMode = 'hidden' | 'single' | 'multi'

export interface BreadcrumbPageConfig {
	adAccount: SelectorMode
	campaign: SelectorMode
	/**
	 * Restricts which ad accounts are selectable in the single/multi selector.
	 * `gads-only` — non-Google accounts are shown but disabled (Refunds Agent, §2).
	 */
	adAccountFilter?: 'gads-only'
}

const BREADCRUMB_PAGE_CONFIG: Array<{ match: RegExp; config: BreadcrumbPageConfig }> = [
	// Analytics Report (DEV-2377) — both selectors are multi-select per §1.3. Must
	// precede the /reports hidden entry; the two paths don't overlap, but keeping
	// the more specific one first guards against a future looser /reports regex.
	{ match: /\/asset\/[^/]+\/analytics-reports/, config: { adAccount: 'multi', campaign: 'multi' } },
	{ match: /\/asset\/[^/]+\/clicks/, config: { adAccount: 'multi', campaign: 'multi' } },
	{ match: /\/asset\/[^/]+\/exclusions/, config: { adAccount: 'multi', campaign: 'multi' } },
	{ match: /\/asset\/[^/]+\/blacklist/, config: { adAccount: 'multi', campaign: 'multi' } },
	{ match: /\/asset\/[^/]+\/reports/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	{ match: /\/asset\/[^/]+\/protection/, config: { adAccount: 'single', campaign: 'single' } },
	{ match: /\/asset\/[^/]+\/refunds/, config: { adAccount: 'single', campaign: 'hidden', adAccountFilter: 'gads-only' } },
	{ match: /\/asset\/[^/]+\/custom-rules/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	{ match: /\/asset\/[^/]+\/ai-protection/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	{ match: /\/asset\/[^/]+\/ppc-accounts/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	{ match: /\/asset\/[^/]+\/site-preference/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	{ match: /\/asset\/[^/]+\/tracking-code/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	{ match: /\/asset\/[^/]+\/conversion-tracking/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	{ match: /workspace\/[^/]+\/connections/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	{ match: /workspace\/affiliate/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	{ match: /\/settings/, config: { adAccount: 'hidden', campaign: 'hidden' } },
	// Dashboard (asset root) — must come last because the regex matches any /asset/:id
	{ match: /\/asset\/[^/]+\/?$/, config: { adAccount: 'multi', campaign: 'multi' } }
]

export const resolveBreadcrumbConfig = (pathname: string): BreadcrumbPageConfig => {
	const hit = BREADCRUMB_PAGE_CONFIG.find(({ match }) => match.test(pathname))
	return hit?.config ?? { adAccount: 'hidden', campaign: 'hidden' }
}
